import React from 'react';
import { gql } from '@apollo/client';
import LoadingBar from '../../components/global/loadingBar';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';
import VendorUsersListRow from '../../components/vendorUsersListRow';
import InviteUser from '../../components/modals/adminTools/inviteUser';

const getVendorUsers = gql`
	query VendorsTenantUsers {
		vendorsTenantUsers {
			displayName
			email
			firstName
			id
			isEmailVerified
			lastName
			phoneNumber
		}
	}
`;

const inviteVendorUser = gql`
	mutation DenormaliseUserInVendor($email: String!) {
		denormaliseUserInVendor(email: $email) {
			message
		}
	}
`;

const removeVendorUser = gql`
	mutation RemoveUserFromVendor($email: String!) {
		removeUserFromVendor(email: $email) {
			message
		}
	}
`;

class VendorUsers extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			searchValue: '',
			vendorUsers: [],
			searchVendorUsers: [],
			isLoading: true,
			showCreateUserModal: false,
		};
	}

	componentDidMount = () => {
		this.getVendorUsers(getVendorUsers, {});
	};

	handleSearch = (e) => {
		this.setState(
			{
				searchValue: e.target.value,
			},
			() => {
				this.computeSearchUsers();
			},
		);
	};

	toggleCreateUser = (e) => {
		this.setState({
			showCreateUserModal: !this.state.showCreateUserModal,
		});
	};

	removeVendorUser = (email) => {
		let json = {
			email,
		};

		this.handleInviteVendorUser(removeVendorUser, json, 'remove');
	};

	afterUpdateVendorUser = () => {
		this.setState({
			isLoading: true,
			searchValue: '',
			searchVendorUsers: [],
		});
		this.getVendorUsers(getVendorUsers, {});
	};

	computeSearchUsers = () => {
		if (_.size(this.state.searchValue.trim()) === 0) {
			this.setState({
				searchVendorUsers: [],
			});
		} else {
			let searchVendorUsers = [];
			searchVendorUsers = _.filter(this.state.vendorUsers, (user, index) => {
				let fullName = user.firstName + ' ' + user.lastName;
				if (
					fullName
						.trim()
						.toLowerCase()
						.includes(this.state.searchValue.trim().toLowerCase()) ||
					(_.size(user.displayName) > 0 &&
						user.displayName
							.trim()
							.toLowerCase()
							.includes(this.state.searchValue.trim().toLowerCase()))
				) {
					return true;
				} else {
					return false;
				}
			});

			this.setState({
				searchVendorUsers,
			});
		}
	};

	handleInviteUser = (email) => {
		let json = {
			email,
		};

		this.handleInviteVendorUser(inviteVendorUser, json);
	};

	render() {
		return (
			<div className="vu-container">
				{this.state.isLoading ? (
					<>
						<LoadingBar />
					</>
				) : (
					<>
						<div
							className="searchContainer"
							style={{
								width: 'auto',
								width: 'calc(100vw - 246px)',
								justifyContent: 'flex-start',
							}}
						>
							<div
								className="searchWrapper"
								style={{ height: '36px', paddingLeft: '16px' }}
							>
								<div className="search-inner-left">
									<input
										placeholder="Search User"
										// name={this.state.searchType}
										value={this.state.searchValue}
										onChange={(event) => this.handleSearch(event)}
									/>
								</div>
								<div className="search-inner-right">
									<span
										className="search-dropdown-btn"
										style={{ position: 'relative' }}
									>
										<a className="search-type">
											<b>
												<p
													style={{
														paddingRight: '20px',
													}}
												>
													Search
												</p>
											</b>
										</a>
									</span>
								</div>
							</div>
							<div
								className="create-shoot-btn"
								onClick={() => this.toggleCreateUser()}
							>
								+ Add member
							</div>
						</div>
						<div className="vu-table-container">
							{(_.size(this.state.searchValue.trim()) > 0 &&
								_.size(this.state.searchVendorUsers) > 0) ||
							_.size(this.state.vendorUsers) > 0 ? (
								<table>
									<tr>
										<th className="vu-name-column">Name</th>
										<th className="vu-email-column">Phone Number & Email</th>
									</tr>
									{_.map(
										_.size(this.state.searchValue.trim()) > 0
											? this.state.searchVendorUsers
											: this.state.vendorUsers,
										(user) => {
											return (
												<VendorUsersListRow
													data={user}
													removeVendorUser={this.removeVendorUser}
												/>
											);
										},
									)}
								</table>
							) : (
								'No data'
							)}
						</div>
					</>
				)}
				{this.state.showCreateUserModal === true ? (
					<InviteUser
						close={this.toggleCreateUser}
						show={this.state.showCreateUserModal}
						userList={this.state.vendorUsers}
						handleInviteUser={this.handleInviteUser}
					/>
				) : null}
			</div>
		);
	}
}

export default withRouter(VendorUsers);
